<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          outlined
          hide-details
          class="required"
          autocomplete="off"
          label="Nome da configuração"
          maxlength="100"
          :error="$v.configuracao.nome.$error"
          @blur="$v.configuracao.nome.$touch()"
          v-model="configuracao.nome"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <px-autocomplete-users
          outlined
          hide-details
          label="Usuários responsáveis"
          autocomplete="off"
          v-model="configuracao.users"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-switch
          hide-details
          v-model="configuracao.ativo"
          label="Configuração ativa"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="12">
        <v-btn color="primary"
               @click="emitNext">
          Próximo
        </v-btn>
        <v-btn class="ml-2" text @click="emitCancel">Cancelar</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    configuracao: Object,
  },
  data() {
    return {};
  },
  methods: {
    emitNext() {
      if (this.validateForm()) {
        return;
      }
      this.$emit('next');
    },
    emitCancel() {
      this.$emit('cancel');
    },
  },
  created() {},
  validations: {
    configuracao: {
      nome: {
        required,
      },
      fornecedor: {
        required,
      },
    },
  },
};
</script>
